import React from "react";

const ManifestoListScreen = () => {
  return (
    <div>
      <h1>Manifesto List</h1>
    </div>
  );
};

export default ManifestoListScreen;
